import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Social media',
  name: 'socialMedia',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
      initialValue: 'Social media block',
      readOnly: true,
    }),
  ],
})